import { render } from "./app-form-view.vue?vue&type=template&id=c7c05774&scoped=true"
import script from "./app-form-view.vue?vue&type=script&lang=js"
export * from "./app-form-view.vue?vue&type=script&lang=js"

import "./app-form-view.vue?vue&type=style&index=0&id=c7c05774&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7c05774"]])

export default __exports__